// extracted by mini-css-extract-plugin
export default {"wine":"index_wine_vl4im"};